import { HttpConstants } from './httpConstants';
import GroupFolderAction from './GroupFolderAction';

export default function getHttpMethodForGroupFolderAction(action: GroupFolderAction) {
    let httpMethod = '';

    switch (action) {
        case GroupFolderAction.GetFolder:
            httpMethod = HttpConstants.Get;
            break;
        case GroupFolderAction.CreateFolder:
        case GroupFolderAction.CopyFolder:
        case GroupFolderAction.MoveFolder:
            httpMethod = HttpConstants.Post;
            break;
        case GroupFolderAction.RenameFolder:
            httpMethod = HttpConstants.Patch;
            break;
        case GroupFolderAction.DeleteFolder:
            httpMethod = HttpConstants.Delete;
            break;
        default:
            throw new Error('This GroupFolderAction is not supported');
    }

    return httpMethod;
}
